import { Component, OnInit, ViewChild,Renderer2} from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from "angular-datatables";
import {  Subject } from "rxjs";
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs/Observable';

import * as _ from 'lodash';
import { TaskService } from 'src/app/services/task.service';
import { SharerService } from 'src/app/services/sharer.service';
import { AlertComponent } from '../../alert/alert.component';
declare var $: any;
declare var jQuery: any;


@Component({
  selector: 'app-upsi-sharer',
  templateUrl: './upsi-sharer.component.html',
  styleUrls: ['./upsi-sharer.component.css']
})
export class UPSISharerComponent implements OnInit {
    isShowEncryptedPAN : boolean=false;
  public environmentSettings: any;
  @ViewChild(DataTableDirective, { static: true })
  dtElement: DataTableDirective;
  dtSharerList: DataTables.Settings = {};
  dtOptions: DataTables.Settings = {};
  dtsharerHistory: DataTables.Settings = {};
  dtnotInsertdata: DataTables.Settings = {};
  dtnotInsertdataTrigger: Subject<any> = new Subject();
  // The trigger needed to re-render the table
  dtHistoryTrigger: Subject<any> = new Subject();
  dtTrigger: Subject<any> = new Subject();
  response: boolean;
  shareIdforDeleteShare: any;
  sharerName: any;
  sharerEmpCode: any;
  ShererDesignation: any;
  selectedUniqueIdentifier: any;
  ShererDocument: any;
  ShererEmail: any;
  sharerHistory: any;
  SearchDateFrom: NgbDateStruct; 
   SearchDateTo: any;
  filesToUpload: any;
  fileSizeError: any;
  fileExtension: any;
  fileExtensionError: any;
  isUploadNotValid: boolean;
  notinserteddata: any;
  tmpListener: any;
  fileNameArray:Array<any> = [];
  isSearchDivVisible = false;
   dataArray:any=[];
   isShowUnapproved : Boolean;
   isMakerCheckerUsed =  environment.IsUPSIMakerCheckerUsed
  public    token :any = localStorage.getItem('token')
  private isInitializingDataTable: boolean = false; 
  constructor(
    private router: Router,
    private alert: AlertComponent,
    private commonFunction: CommonFunction,
    private renderer: Renderer2,
    private sharerService: SharerService,
    private taskService: TaskService,
    private route: ActivatedRoute) { 
        this.response = false;
    }
    
   
  ngOnDestroy() {
    this.tmpListener();
}


  ngOnInit(): void {
    this.isMakerCheckerUsed =  environment.IsUPSIMakerCheckerUsed
    this.isShowUnapproved = false;
    this.isShowEncryptedPAN= true;
    this.environmentSettings = environment;
    var $ = jQuery.noConflict();
    // $("body").removeClass("dashboard-page");
    this.selectedUniqueIdentifier = '';
    this.fileSizeError = false;
    this.isUploadNotValid = true;
    this.dtsharerHistory = {
        processing: true,
        serverSide: false,
        scrollX: true,
        deferRender: true,
        stateSave: true,
        stateDuration: -1,
        scrollY: "420px",
        scrollCollapse: true,
        destroy: true,
        pagingType: 'full_numbers',
        paging: true,
        pageLength: 10,
        search: true,
        order: [15, 'desc'],
        lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
        dom: 'lBfrtip',//'Bfrtip',
        buttons: [
            {
                text: '<i class="fa fa-files-o"></i> Export to Excel',
                className: 'btn btn-sm btn-warning export-btn',
                filename: 'Sharer History List',
                title: 'Sharer History List',
                extend: 'excel',
                exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13, 14, 15],
                    format: {
                      body: function ( data, row, column, node ) {
                          if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                            if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                          }else{ return data }
                        }
                    }
                },
              },
              {
                text: '<i class="fa fa-files-o"></i> Export to PDF',
                className: 'btn btn-sm btn-warning export-btn',
                filename: 'Sharer List',
                title: 'Sharer List',
                extend: 'pdf',
                orientation: 'landscape',
                pageSize: 'A3',
                exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 7, 8, 9, 11, 12, 13]
                }
            }
        ]

    }

    this.dtnotInsertdata = {
        processing: true,
        serverSide: false,
        scrollX: true,
        deferRender: true,
        stateSave: true,
        stateDuration: -1,
        scrollY: "420px",
        scrollCollapse: true,
        destroy: true,
        pagingType: 'full_numbers',
        paging: true,
        pageLength: 10,
        search: true,
        order: [0, 'asc'],
        lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
        dom: 'lBfrtip',//'Bfrtip',
        buttons: [
            {
                text: '<i class="fa fa-files-o"></i> Export to Upload Again',
                className: 'btn btn-sm btn-warning export-btn',
                filename: 'Not Inserted Records',
                extend: 'excel',
                title: '',
                exportOptions: {
                    columns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                    format: {
                      body: function ( data, row, column, node ) {
                          if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                            if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                          }else{ return data }
                        }
                    }
                },
            }
        ]

    }


  }

  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  ngAfterViewInit(): void {
    // Initialize DataTable after view is initialized and DOM is ready
    setTimeout(() => {
      this.getSharerList({});
    }, 0);
    
    this.tmpListener = this.renderer.listen('document', 'click', (event) => {
        if (event.target.hasAttribute("update-sharer")) {
            this.editSharerByID(event.target.getAttribute("update-sharer"));
            return;
        }
        if (event.target.hasAttribute("delete-sharer")) {
            this.deleteSharerById(event.target.getAttribute("delete-sharer"));
            return;
        }

        if (event.target.hasAttribute("history-sharer")) {
            this.historySharerById(event.target.getAttribute("history-sharer"));
            return;
        }

        if (event.target.hasAttribute("download-sharer-doc")) {
            this.openDownloadModal(event.target.getAttribute("download-sharer-doc"));
            return;
        }
        if (event.target.hasAttribute("approve-sharer")) {
            // console.log(event.target.getAttribute("approve-sharer"));
            this.approveSharerByID(event.target.getAttribute("approve-sharer"));
            return;
        }

    });
    
}

approveSharerByID(sharerId) {
    // alert("Approve sharer called sharerId:" +sharerId)

    var user_local = JSON.parse(localStorage.getItem("user"));
    var roles = user_local.Roles
    var SYSTEM_DEFINED_UPSI_CHECKER = roles.filter(role=>{ return role.RoleName == "SYSTEM_DEFINED_UPSI_CHECKER" || role.RoleName == "Admin" || role.RoleName == "Trial" });

    if(SYSTEM_DEFINED_UPSI_CHECKER.length<=0){
      alert("Need SYSTEM_DEFINED_UPSI_CHECKER Role to approve!");
      return;
    }else{
       
        this.sharerService.approveSharer(sharerId).subscribe((response)=>{
            if(!response.status){
                alert("UPSI Sharer approved");
            }else{
                alert("UPSI Sharer approval failed !");
            }
        })
    }

    //this.router.navigate(['/sharer/approve/', sharerId]);
}
historySharerById(sharerId) {

    let usersList = this.taskService.getUsersList();
    let sharerList = this.sharerService.getSharerHistory(sharerId);

    Observable.forkJoin([sharerList, usersList])
        .subscribe((response) => {
            
            var sharerHistoryData;
            if (response[0].status == 0) {
                sharerHistoryData = response[0].data

            } else {
                sharerHistoryData = {};
            }
            var usersData;
            if (response[1].status == 0) {
                usersData = response[1].result;
            } else {
                usersData = {};
            }
            var sharerHisData = [];
              _.forEach(sharerHistoryData, function (sharer) {
                var CreatedByUser = _.filter(usersData, ["_id", sharer.d.CreatedBy]);
                _.assign(sharer, { CreatedByUserName: (CreatedByUser[0] != null || CreatedByUser[0] != undefined) ? (CreatedByUser[0].FirstName + " " + CreatedByUser[0].LastName) : "" })
                var ModifiedByUser = _.filter(usersData, ["_id", sharer.d.ModifiedBy]);
                _.assign(sharer, { ModifiedByUserName: (ModifiedByUser[0] != null || ModifiedByUser[0] != undefined) ? (ModifiedByUser[0].FirstName + " " + ModifiedByUser[0].LastName) : "" })
                sharerHisData.push(sharer);
            })

            $("#sharerHistorytable").DataTable().destroy();
            this.sharerHistory = sharerHisData;
            this.dtHistoryTrigger.next();

            $('#historyModel').modal('show');
        });
}

add(dataArray){
    // var dataArray=this.dataArray
    
   
    // const routeSegments = Array.isArray(sharer) ? sharer : ['userMaster', 'upsisharer', 'sharer', 'add', sharer];
    // console.log(routeSegments)

    this.router.navigate(
        [{ outlets: { 'structure-outlet': ['userMaster', 'upsisharer', 'sharer', 'add', JSON.stringify(dataArray)]  } }],
        { relativeTo: this.route.parent }
      );
}
editSharerByID(sharerId) {
    // this.router.navigate(['/userMaster/upsimaster/sharer/edit']);
    // var dataArray=this.dataArray.push(sharerId)

    // sharerId=sharerId.push(this.dataArray)
    if(this.isMakerCheckerUsed){
        var user_local = JSON.parse(localStorage.getItem("user"));
        var roles = user_local.Roles
        var SYSTEM_DEFINED_UPSI_CHECKER = roles.filter(role=>{ return role.RoleName == "SYSTEM_DEFINED_UPSI_CHECKER" || role.RoleName == "Admin" || role.RoleName == "Trial" });
    
        if(SYSTEM_DEFINED_UPSI_CHECKER.length<=0){
          alert("Need SYSTEM_DEFINED_UPSI_CHECKER Role to approve!");
          return;
        }
    }
    this.router.navigate(
        [{ outlets: { 'structure-outlet': ['userMaster', 'upsisharer', 'sharer', 'edit',JSON.stringify({'sharerId':sharerId,'data': JSON.stringify(this.dataArray)})] } }],
        { relativeTo: this.route.parent }
      );

}
deleteSharerById(sharerID) {

    this.shareIdforDeleteShare = sharerID;
    $('#deleteSharerConfirmation').modal('show');
}

deleteSharer() {


    new Promise(resolve => this.sharerService.deleteSharer(this.shareIdforDeleteShare).subscribe((response) => {
        if (response.status == 1) {
            this.alert.error(response.message);
        } else {
            this.getSharerList({});
            this.alert.success(response.message);

        }

    }))


}
searchData() {

    if (this.sharerName == null && this.sharerEmpCode == null && this.ShererDesignation == null
        && this.selectedUniqueIdentifier == '' && this.ShererDocument == null && this.ShererEmail == null && this.SearchDateFrom == null && this.SearchDateTo == null
        && !this.isShowUnapproved) {
        this.alert.success("Enter  one of search data.");
        return;

    }
    // console.log(this.SearchDateFrom+".....date");
    var paramData = {
        Name: (this.sharerName != null && this.sharerName.trim() != '' && _.size(this.sharerName.trim())) ? this.sharerName.trim().toLowerCase() : {},
        EmpCode: (this.sharerEmpCode != null && this.sharerEmpCode.trim() != '' && _.size(this.sharerEmpCode.trim())) ? this.sharerEmpCode.trim().toLowerCase() : {},
        Designation: (this.ShererDesignation != null && this.ShererDesignation.trim() != '' && _.size(this.ShererDesignation.trim())) ? this.ShererDesignation.trim().toLowerCase() : {},
        Unique_Identifier_Type: (this.selectedUniqueIdentifier != null && this.selectedUniqueIdentifier.trim() != '' && _.size(this.selectedUniqueIdentifier.trim())) ? this.selectedUniqueIdentifier.trim() : {},
        Document_No: (this.ShererDocument != null && this.ShererDocument.trim() != '' && _.size(this.ShererDocument.trim())) ? this.ShererDocument.trim().toLowerCase() : {},
        email_id: (this.ShererEmail != null && this.ShererEmail.trim() != '' && _.size(this.ShererEmail.trim())) ? this.ShererEmail.trim().toLowerCase() : {},
        CreatedFrom: (this.SearchDateFrom != null &&  _.size(this.SearchDateFrom)) ? this.setDate(this.SearchDateFrom) : {},
        CreatedTo: (this.SearchDateTo != null && this.SearchDateTo != '' && _.size(this.SearchDateTo)) ? this.setDate(this.SearchDateTo) : {},
        isShowUnapproved : this.isShowUnapproved
    }
    this.getSharerList(paramData);

}

handleCheckboxChange() {
    this.getSharerList({});
  }
clear() {
    var paramData = {}
    this.sharerName = null;
    this.sharerEmpCode = null;
    this.ShererDesignation = null;
    this.selectedUniqueIdentifier = '';
    this.ShererDocument = null;
    this.ShererEmail = null;
    this.isShowEncryptedPAN=false;
    this.SearchDateFrom = null;
    this.SearchDateTo = null;
    this.getSharerList(paramData);
}



upload() {
    var file = this.filesToUpload;
    if (file != undefined) {
        this.makeFileRequest(environment.pssServerUrl + "sharer/csvUplaodAddSharer", [], file).then((result) => {
            $("#fileInput").val('');
            this.isUploadNotValid = true;
            if (result['status'] == 0) {

                this.notinserteddata = result['data'];
                $("#CsvUploadtable").DataTable().destroy();
                this.dtnotInsertdataTrigger.next();

                if (_.size(result['data'])) {

                    $('#notInsertdata').modal('show');
                }
                else {
                    this.alert.success("All records are successfully inserted.");
                }
                this.getSharerList({});

            } else {
                this.alert.error("File is empty.");
                this.getSharerList({});
            }

        });
    } else {
        // console.log("file undefined")
    }
}


makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
        var formData: any = new FormData();
        var xhr = new XMLHttpRequest();
        for (var i = 0; i < files.length; i++) {
            var newDate = Date.now();
            formData.append("file", files[i], newDate + '-' + files[i].name.replace(',', ''));
        }
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    resolve(JSON.parse(xhr.response));
                } else {
                    reject(xhr.response);
                }
            }
        }
        xhr.open("POST", url, true);
        var token = localStorage.getItem('token')            
        xhr.setRequestHeader('x-access-token', token)
        xhr.setRequestHeader('userdetail', this.getUserDetail())
        xhr.setRequestHeader('pssdetail', localStorage.getItem("companyDetails"))        
        xhr.send(formData);

    });
}
getUserDetail() {
    var user = JSON.parse(localStorage.getItem("user"));
    var resources = JSON.parse(localStorage.getItem("resources"));
    var companyDetails = JSON.parse(localStorage.getItem("companyDetailsGoveva"));
    var resourcesData = resources.filter(function (item) {
        return item.Menu === 'UPSI';
    })[0]

    var upsiAdmin;
    if (resourcesData) {
        upsiAdmin = (resourcesData['Menu']) ? true : false
    } else {
        upsiAdmin = false
    }

    var decrEmailId=this.commonFunction.decrypt(user.EmailId);

    var loginUser = {
        id: user._id,
        firstName: user.FirstName,
        lastName: user.LastName,
        upsiAdmin: upsiAdmin,
        // EmailId: user.EmailId,
        EmailId: decrEmailId,
        companyDetails: companyDetails,
        title: user.Title
    }

    return JSON.stringify(loginUser);
}

allExtensions()
{
    return ["csv", "xlsx", "xls", "jpg", "jpeg", "png", "doc", "docx", "txt", "pdf", "ppt","pptx", "mp4","apk","bat","bin","cgi","com","exe","jar","py","wsf","aif","cda","iff","mid","midi","mp3","mpa","wav","wma","wpl","avi","flv","h264","m4v","mkv","mov","mpg","mpeg","rm","swf","vob","wmv","3g2","3gp","odt","msg","rtf","tex","wks","wps","wpd","ods","xlr","key","odp","pps","accdb","dat","db","dbf","log",
    "mdb","pdb","sav","sql","tar","bak","cab","cfg","cpl","cur","dll","dmp","drv","icns","ico","ini","lnk","msi","sys","tmp","asp","aspx","cer","cfm","cgi","pl","css","htm","html","js","jsp","part","php","rss","xhtml","ai","bmp","gif","ico","max","obj","ps","psd","svg","tif","tiff","3ds","3dm"];
            
}

isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
}

fileChanged($event) {

    var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect($event,$event)
    if (filenameValidation == "Valid") {
        if ($event.target.files[0] / (1024 * 1024) > (1024 * 1024)) {
            this.fileSizeError = true;
            this.isUploadNotValid = true;
        } else {
            var count=0;
            var self=this;
            var allowedExtensions = ["csv", "CSV", "xlsx", "XLSX"];
            var filename = $event.target.files[0].name;
            var checkFilesExtension=filename.toString().split('.').pop();
             this.fileExtension = filename.split('.');

            this.fileExtension.forEach(function(value, key) {
                if(self.isInArray(self.allExtensions(), value))
                {
                    count++; 
                }
              });
    
            //this.fileExtension = filename.toString().split('.').pop();
           // console.log("filename", filename);
           

            if (count==1 && self.isInArray(allowedExtensions, checkFilesExtension)) {
                this.fileExtensionError = false;
                this.fileSizeError = false;
                this.isUploadNotValid = false;
                this.filesToUpload = $event.target.files;
            } else {
                this.fileExtensionError = true;
                this.isUploadNotValid = true;
            }
        }
    } else {
        this.alert.error(filenameValidation);
    }

    
}

setDate(date) {
    if (date != "" && date != null) {
        return date.year + "-" + date.month + "-" + date.day;
    }
    return null;
}
getSharerList(paramData) {
       // Prevent concurrent initialization
       if (this.isInitializingDataTable) {
         return;
       }
       
       var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
        paramData.companyID = companyDetails.companyID;
        var token = localStorage.getItem('token')        
        var self = this;
        
        // Destroy existing DataTable if it exists to prevent duplicate requests
        if ($.fn.DataTable && $.fn.DataTable.isDataTable('#datatableMeeting')) {
          try {
            $('#datatableMeeting').DataTable().destroy();
          } catch (error) {
            console.error('Error destroying DataTable:', error);
          }
        }
        
        // Check if table element exists before initializing
        const tableElement = document.getElementById('datatableMeeting');
        if (!tableElement) {
          console.warn('Table element #datatableMeeting not found, retrying...');
          setTimeout(() => {
            this.getSharerList(paramData);
          }, 100);
          return;
        }
        
        this.isInitializingDataTable = true;
        
        var dataTable =$('#datatableMeeting').DataTable({
            ajax: {
                // url: environment.pssUrl + "dataTable/sharer/" + JSON.parse(localStorage.getItem("companyDetails")).companyID,
                url: environment.pssServerUrl + "dataTable/sharer",
                type: 'post',
                data: paramData,
                headers: { "x-access-token": token },
                cache: true
            },
            columns: [{
                title: 'Name',
                width: "30%",
                render: function (data: any, type: any, full: any) {
                    return full.Name

                }
            },
            {
                title: 'Sharer Code',
                width: "15%",
                render: function (data: any, type: any, full: any) {
                    return full.EmpCode
                }
            }, {
                title: 'Designation',
                width: "15%",
                render: function (data: any, type: any, full: any) {
                    return full.Designation
                }
            }, {
                title: 'Unique Identifier Type',
                width: "15%",
                render: function (data: any, type: any, full: any) {

                    return full.Unique_Identifier_Type == 'Other' ? full.other_document_name : full.Unique_Identifier_Type
                }
            }, {
                title: "Document No",
                width: "20%",
                render: function (data: any, type: any, full: any) {
                    // return full.Document_No.toUpperCase();
                    return self.isShowEncryptedPAN ? '**********': full.Document_No.toUpperCase();
                }

            }, {
                title: "Email Id",
                width: "20%",
                render: function (data: any, type: any, full: any) {
                    // For display, show masked email
                    if (type === 'display') {
                        const [username, domain] = full.email_id.split('@');
                        return username && domain ? `${username.slice(0, 3)}******@${domain}` : '';
                    }
                    // For export, return original unmasked email
                    return full.email_id || '';
                }

            }, {
                title: 'Action',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    // return '<div class="input-group"><button type="button"  title="Edit" update-sharer=' + full._id + ' class="btn-sm btn btn-warning" ><span class="fa fa-pencil"  update-sharer=' + full._id + '></span></button>&nbsp;&nbsp;<button  type="button"  title="Delete" delete-sharer=' + full._id + ' class="btn-sm btn btn-danger" ><span class="icmn-bin"  delete-sharer=' + full._id + '></span></button>&nbsp;&nbsp;<button   title="History" type="button" history-sharer=' + full._id + ' class="btn-sm btn btn-warning" ><span class="icmn-history"  history-sharer=' + full._id + '></span></button></div>';
                    var buttonsText = '<div class="input-group ">';
                    
                    if(!full.IsCheckerApproved){
                        buttonsText = buttonsText + '<button type="button"  title="Approve" approve-sharer=' + full._id + ' class="btn-sm btn btn-success" ><span class="fa fa-check"  approve-sharer=' + full._id + '></span></button>&nbsp;&nbsp;';
                    }
                    if (self.commonFunction.validateModulePermitions('UPSI Sharer', '/uspiSharer/edit')) {

                        buttonsText = buttonsText + '<button type="button"  title="Edit" update-sharer=' + full._id + ' class="btn-sm1 btn btn-warning" ><span class="fa fa-pencil"  update-sharer=' + full._id + '></span></button>&nbsp;&nbsp;';
                    }

                    if (self.commonFunction.validateModulePermitions('UPSI Sharer', '/uspiSharer/delete')) {
                        buttonsText = buttonsText + '<button  type="button"  title="Delete" delete-sharer=' + full._id + ' class="btn-sm1 btn btn-danger" ><span class="icmn-bin"  delete-sharer=' + full._id + '></span></button>&nbsp;&nbsp;';
                    }


                    if (full.DocumentFile) {
                        buttonsText = buttonsText + '<button type="button" title="download" download-sharer-doc="' + [full.DocumentFile] + '"  class="btn btn-sm1 btn-primary"><span class="fa fa-download" download-sharer-doc="' + [full.DocumentFile] + '"></span></button>&nbsp;';
                    }


                    buttonsText = buttonsText + '<button   title="History" type="button" history-sharer=' + full._id + ' class="btn-sm1 btn btn-warning" ><span class="icmn-history"  history-sharer=' + full._id + '></span></button></div>';


                    return buttonsText;
                }
            },
            {
                title: 'Department',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    return full.Department

                }
            },
            {
                title: 'Contact Number',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    return full.ContactNumber

                }
            },
            {
                title: 'Tel Number',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    return full.tele_Number

                }
            },
            {
                title: 'Other Document Name',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    return (full.other_document_name) ? full.other_document_name : "-"

                }
            }, {

                title: 'Created Date',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    return self.roundDigit(new Date(full.CreatedDate).getDate()) + '-' + (new Date(full.CreatedDate).getMonth() + 1) + '-' + new Date(full.CreatedDate).getFullYear() + ''

                }
            }, {

                title: 'Document File',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    return (full.DocumentFile) ? full.DocumentFile : ""
                }
            }, {

                title: 'Modified Date',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    if (full.ModifiedDate) {
                        return self.roundDigit(new Date(full.ModifiedDate).getDate()) + '-' + (new Date(full.ModifiedDate).getMonth() + 1) + '-' + new Date(full.ModifiedDate).getFullYear() + ''
                    } else {
                        return null
                    }
                }
            }
            ],
            processing: true,
            serverSide: false,
            scrollX: true,
            deferRender: true,
            stateSave: true,
            stateDuration: -1,
            scrollY: "420px",
            scrollCollapse: true,
            destroy: true,
            pagingType: 'full_numbers',
            paging: true,
            pageLength: 10,
            search: true,
            order: [0, 'asc'],
            columnDefs: [{ orderable: false, targets: [6] }, { className: "hide_col", targets: [7, 8, 9, 10, 11, 12, 13] }],
            lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
            dom: 'lBfrtip',//'Bfrtip',
            buttons: [
                {
                    text: '<i class="fa fa-files-o"></i> Export to Excel',
                    className: 'btn btn-sm btn-warning export-btn',
                    filename: 'Sharer List',
                    title: 'Sharer List',
                    extend: 'excel',
                    exportOptions: {
                        columns: [0, 1, 2, 3, 4, 5, 7, 8, 9, 11, 12, 13],
                        orthogonal: 'export',
                        format: {
                          body: function ( data, row, column, node ) {
                            // The render function will automatically provide the export value
                            // But we still need to handle special characters for Excel
                            if (typeof data === 'string' && (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!"))) {
                                if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) {
                                  return data;
                                } else {
                                  return "'" + data + "'";
                                }
                              } else if (typeof data === 'number' || typeof data === 'boolean') {
                                return data.toString();
                              } else {
                                return data;
                              }
                            }
                        }
                    }
                },
                {
                    text: '<i class="fa fa-files-o"></i> Export to PDF',
                    className: 'btn btn-sm btn-warning export-btn',
                    filename: 'Sharer List',
                    title: 'Sharer List',
                    extend: 'pdf',
                    orientation: 'landscape',
                    pageSize: 'A3',
                    exportOptions: {
                        columns: [0, 1, 2, 3, 4, 5, 7, 8, 9, 11, 12, 13],
                        orthogonal: 'export'
                    }
                }
            ],
            initComplete: function() {
              // Reset flag after DataTable is fully initialized
              self.isInitializingDataTable = false;
            }
        });
        this.response = false;
        // Remove ajax.reload() as it causes duplicate requests - DataTable already loads data on init
        // $('#datatableMeeting').DataTable().ajax.reload();
        dataTable.on('draw.dt', function () {
            // Get the data in the DataTable
            var data = dataTable.rows().data();

            // Convert DataTables internal representation to a standard array of objects
            self.dataArray = data.toArray();
        
            // Now you can work with the actual data, for example, log it to the console
        });
}
roundDigit(val) {

    var str = new String(val);

    if (str.length == 1) {
        return (0 + '' + val);
    } else {
        return parseInt(val);
    }
}

openDownloadModal(files){
    this.fileNameArray = files.split(',')
    $("#UpsiFileDownloadTitle").html("Attachments of Emails");
    $("#upsiDetailsFileDownloadDialog").modal('toggle');
  }


downloadSharerDoc(fileName){
    let token = localStorage.getItem('token')
    window.location.href = environment.pssServerUrl + "upsi/sharerDoc/" + fileName + "/" + token
}
}

